import React, { useEffect, useRef, useState } from "react";
import { Wrench, ShieldAlert } from "lucide-react";
import { fetchSiteStatus } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import AuthDialog from "@/components/AuthDialog";

const MaintenancePage = () => {
  const [authOpen, setAuthOpen] = useState(false);
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#f5f1e8] px-6 text-center" data-testid="maintenance-page">
      <div className="font-display text-4xl font-bold text-slate-900">Ver<span className="text-emerald-700">B</span></div>
      <div className="text-[11px] tracking-[0.25em] uppercase text-slate-500 mt-1">Vertual Bazaar</div>
      <div className="mt-10 w-16 h-16 rounded-2xl bg-emerald-50 border border-emerald-100 flex items-center justify-center"><Wrench className="w-8 h-8 text-emerald-700" /></div>
      <h1 className="mt-6 font-display text-3xl sm:text-4xl font-bold text-slate-900" data-testid="maintenance-title">We'll be back shortly</h1>
      <p className="mt-3 max-w-md text-sm sm:text-base text-slate-600" data-testid="maintenance-message">
        VerB is temporarily unavailable for maintenance. Aapka data surakshit hai — thodi der baad dobara try karein.
      </p>
      <button type="button" onClick={() => setAuthOpen(true)} className="mt-12 text-xs text-slate-400 hover:text-slate-600 underline underline-offset-4" data-testid="maintenance-admin-login">Admin sign in</button>
      <AuthDialog open={authOpen} onOpenChange={setAuthOpen} />
    </div>
  );
};

// Shows the Maintenance Page to everyone except a signed-in Admin while the website is paused.
export default function MaintenanceGate({ children }) {
  const { isAdmin, authChecking } = useApp();
  const [paused, setPaused] = useState(false);
  const [ready, setReady] = useState(false);
  const blockedAt = useRef(0);
  useEffect(() => {
    // A maintenance 503 seen in the last 10s wins over a status reply that was already in flight.
    const check = () => fetchSiteStatus().then((s) => setPaused(!!s.paused || Date.now() - blockedAt.current < 10000)).catch(() => {}).finally(() => setReady(true));
    check();
    const failSafe = setTimeout(() => setReady(true), 3000);
    const onBlocked = () => { blockedAt.current = Date.now(); setPaused(true); setReady(true); };
    window.addEventListener("vb:maintenance", onBlocked);
    const timer = setInterval(check, 60000);
    return () => { window.removeEventListener("vb:maintenance", onBlocked); clearInterval(timer); clearTimeout(failSafe); };
  }, []);
  // First load: decide before rendering pages, so paused visitors never see half-loaded pages or "server busy" errors.
  if (!ready) return null;
  if (paused && !authChecking && !isAdmin) return <MaintenancePage />;
  return (
    <>
      {paused && isAdmin && (
        <div className="bg-red-600 text-white text-xs sm:text-sm font-semibold px-4 py-2 flex items-center justify-center gap-2 text-center" data-testid="site-paused-admin-banner">
          <ShieldAlert className="w-4 h-4 flex-shrink-0" /> Website is PAUSED — public visitors see the Maintenance Page. Resume it from the Admin Panel.
        </div>
      )}
      {children}
    </>
  );
}
